import 'css-chunksrc/client/scenes/event/datesPickers/styles.scss';export default {
  "dateForm": "_dateForm_1lhze_1",
  "group": "_group_1lhze_7",
  "wrapper": "_wrapper_1lhze_14",
  "input": "_input_1lhze_45",
  "icon": "_icon_1lhze_49",
  "title": "_title_1lhze_55",
  "calendar": "_calendar_1lhze_77",
  "datesWrapper": "_datesWrapper_1lhze_84"
};